import http from './method.js'

// 分类列表
export const categoryList = () => {
  return http().get('/course/api/category/list')
}
// 首页推荐课程
export const apply = (params = {}) => {
  return http().post('/api/system/articleApproval/add', params)
}
// 获取当前登录用户的申请列表
export const getApprovalPersonal = (params = {}) => {
  return http().get('/api/system/articleApproval/index/?' + params)
}
// 获取当前登录用户的申请列表
export const getReleaseArticle = (params = {}) => {
  return http().get('/api/system/articleApproval/index?' + params)
}

// 下载文件
export const download = (params = {}) => {
  return http('', {responseType: 'blob'}).post('/api/system/common/download?fileName=' + params)
}

